import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import overlayManager from "../lib/overlay_manager"

// Connects to data-controller="modal"
export default class extends Controller {
  static values = { id: String }

  connect() {
    this.overlayRegistered = false
    this.closingFromPopstate = false

    if (!this.idValue) {
      return
    }

    this.modalElement = document.body.querySelector(`#${this.idValue}Wrapper`)
    if (this.modalElement) {
      this.menu = this.modalElement
      this.modal = Modal.getInstance(this.menu)
    }
  }

  open(event) {
    if (this.modal)
      return

    // this.backdrop = document.createElement("div")
    // this.backdrop.classList.add("modal-backdrop", "fade")
    // this.backdrop.setAttribute("data-action", "click->modal#close")

    const dialogClass = ["modal-dialog", "modal-dialog-scrollable", event.currentTarget.dataset.modalDialogClass].filter(Boolean).join(" ")

    this.menuHTML = `
      <div class="pt-safe-area pb-safe-area modal fade" id="${event.currentTarget.dataset.turboFrame}Wrapper" tabindex="-1">
        <div class="${dialogClass}">
          <turbo-frame id="${event.currentTarget.dataset.turboFrame}" data-controller="modal" data-modal-id-value="${event.currentTarget.dataset.turboFrame}">
            <div class="modal-content placeholder-glow">
              <div class="modal-header">
                <h1 class="modal-title fs-5 placeholder" id="${event.currentTarget.dataset.turboFrame}WrapperLabel">Loading...</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="d-flex justify-content-center align-items-center" style="height: 300px">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </turbo-frame>
        </div>
      </div>
    `
    document.body.insertAdjacentHTML("beforeend", this.menuHTML)
    this.menu = document.body.querySelector(`#${event.currentTarget.dataset.turboFrame}Wrapper`)

    this.modal = new Modal(this.menu, {
      backdrop: true,
      scroll: false,
      keyboard: true
    })

    this.menu.addEventListener('shown.bs.modal', function () {
      document.body.style.overflow = "hidden"
    })

    this.menu.addEventListener("hidden.bs.modal", () => {
      document.body.style.overflow = ""

      if (this.overlayRegistered) {
        overlayManager.unregister(this, { fromPopstate: this.closingFromPopstate })
        this.overlayRegistered = false
      }

      this.menu.remove()
      this.modal = null
      this.closingFromPopstate = false
    })

    // this.backdrop.addEventListener("click", () => this.close())

    // this.backdrop.classList.add("show")
    // this.menu.insertAdjacentElement("beforebegin", this.backdrop)
    this.modal.show()
    overlayManager.register(this)
    this.overlayRegistered = true
  }

  close(event) {
    if ((event.detail == 1 || event.detail.success) && this.modal) {
      this.modal.hide()
    }
  }

  disconnect() {
    // this.modal.dispose()
  }

  closeFromOverlayManager() {
    if (!this.modal) {
      return
    }

    this.closingFromPopstate = true
    this.modal.hide()
  }
}
